import { getItem } from '../../../utils/cache';
import {
  ADD_OFFLINE_CART_DATA,
  CHECKOUT_SET_IS_LOADING,
  DO_FETCH_CART_SUCCESS,
  DO_TOGGLE_CART_MODAL,
  SET_CART_IS_LOADING,
} from '../../constant/checkout';
import { RESET_STORE } from '../../constant/common';

const initialState = {
  cart: null,
  isLoading: true,
  cartLoading: true,
  showCartModal: false,
  OfflineCart: JSON.parse(getItem('offlineCart')) || [],
};

export const checkoutReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHECKOUT_SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_CART_IS_LOADING:
      return {
        ...state,
        cartLoading: payload,
      };
    case DO_FETCH_CART_SUCCESS:
      return {
        ...state,
        cart: payload,
      };
    case DO_TOGGLE_CART_MODAL:
      return {
        ...state,
        showCartModal: payload,
      };
    case RESET_STORE:
      return { ...initialState };
    case ADD_OFFLINE_CART_DATA:
      return {
        ...state,
        OfflineCart: payload,
      };
    default:
      return state;
  }
};
